// extracted by mini-css-extract-plugin
export default {"content":"styles_content__Yae8g","fullView":"styles_fullView__iMbY8","shimmer":"styles_shimmer__zYRYz"};